"use strict";

require("./CompanyPublicationWatcherService.js");

PublicationSettingsDirective.$inject = [
  "$q",
  "$window",
  "$http",
  "$state",
  "$translate",
  "CompanyCategoryService",
  "CompanyGroupService",
  "CompanyPublicationWatcherService",
  "CompanyUserService",
  "growl",
  "config",
  "$filter"];
function PublicationSettingsDirective(
  $q,
  $window,
  $http,
  $state,
  $translate,
  CompanyCategoryService,
  CompanyGroupService,
  CompanyPublicationWatcherService,
  CompanyUserService,
  growl,
  config,
  $filter) {
  return {
    restrict: "A",
    templateUrl: "partials/company/publications/aside.html",
    /* Expected scope variables from parent:
     *  * publication:     current publication
     *  * currentCompany:  current company
     *  * savePublication: function to save a given publication
     */
    link: function($scope, el) {
      var data;
      var nonWatchersPromise;

      $scope.nonWatchers             = [];
      $scope.additionalOptionsOpen   = false;
      $scope.additionalOptionsLoaded = false;
      $scope.selectedGroup           = null;
      
      function loadData() {
        if( ! data) {
          var categories = CompanyCategoryService.query({companyId: $scope.currentCompany.id, limit: 100}).$promise;
          var watchers   = CompanyPublicationWatcherService.query({companyId: $scope.currentCompany.id, publicationId: $scope.publication.id}).$promise;
          
          data = $q.all([categories, watchers]).then(function(r) {
            $scope.additionalOptionsLoaded = true;

            $scope.categories = r[0];
            $scope.watchers   = r[1];
          });
        }
        
        return data;
      }
      
      function updateNonWatchers(filter) {
        if( ! $scope.additionalOptionsLoaded) {
          return;
        }
        
        var p = CompanyUserService.query({companyId: $scope.currentCompany.id, q: filter, limit: 6}).$promise.then(function(users) {
          return users.filter(function(item) {
            return !$scope.watchers.some(function(watcher) {
              return item.id === watcher.id;
            });
          });
        }).then(function(nonWatchers) {
          if(nonWatchersPromise === p) {
            /* Correct promise, update */
            $scope.nonWatchers = nonWatchers;
          }
        });
        
        nonWatchersPromise = p;
      }
      
      function openAdditionalOptions() {
        el.addClass("open");
        
        $scope.additionalOptionsOpen = true;
        
        loadData();
      }
      
      function closeAdditionalOptions() {
        el.removeClass("open");
        
        $scope.additionalOptionsOpen = false;
      }
      
      function toggleAdditionalOptions() {
        if($scope.additionalOptionsOpen) {
          closeAdditionalOptions();
        }
        else {
          openAdditionalOptions();
        }
      }
      
      function setPriority(priority) {
        if( ! priority) {
          $scope.publication.priority = null;
        }
        else {
          $scope.publication.priority = priority;
        }

        return $scope.savePublication($scope.publication);
      }

      /* FIXME: Move to service */
      function deletePublication(publication) {
        $http({
          method: 'DELETE',
          url: config.apiBase + '/companies/' + $scope.currentCompany.id + '/publications/' + $scope.publication.id
        }).then(function() {
            growl.addSuccessMessage($translate.instant('publication.remove-success'));

            if (publication.status === 'DRAFT') {
              $state.go('root.company.publications-listDrafts');
            }

            else if (publication.status === 'ARCHIVED') {
              $state.go('root.company.publications-listArchived');
            }

            else {
              $state.go('root.company.publications-list');
            }

        }, function() {
          growl.addErrorMessage($translate.instant('publication.remove-failure'));
        });
      }
      
      function unsetParent() {
        $scope.publication.parent = null;

        $scope.savePublication($scope.publication);
      }

      function setParent(publication) {
        $scope.publication.parent = {
          id:   publication.id,
          name: publication.name
        };

        $scope.savePublication($scope.publication);
      }

      function setCategory(category) {
        if( ! category) {
          $scope.publication.category = null;
        }

        $scope.publication.category = category;

        return $scope.savePublication($scope.publication);
      }

      $scope.addedTags = function(item) {
        return $scope.publication.tags.indexOf(item) === -1;
      };

      /* FIXME: Move to directive */
      $scope.addWatcher = function(watcher) {
        var newWatcher = new CompanyPublicationWatcherService({
          id: watcher.id
        });

        newWatcher.$save({companyId: $scope.currentCompany.id, publicationId: $scope.publication.id}, function() {
          growl.addSuccessMessage($translate.instant('publication.add-watcher-success'));
          $scope.watchers.push(watcher);
          angular.element('#filterWatchers').val(''); // Clear typeahead input
          $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
        }, function() {
          growl.addErrorMessage($translate.instant('publication.add-watcher-failure'));
        });
      };

      $scope.deleteWatcher = function(watcher) {
        CompanyPublicationWatcherService.delete({companyId: $scope.currentCompany.id, publicationId: $scope.publication.id, watcherId: watcher.id}, function() {
          growl.addSuccessMessage($translate.instant('publication.remove-watcher-success'));
          $scope.watchers.splice($scope.watchers.indexOf(watcher), 1);
        }, function() {
          growl.addErrorMessage($translate.instant('publication.remove-watcher-failure'));
        });
      };

      $scope.prioritiesSorted = ($filter('orderBy')($scope.priorities, 'stepNr')).filter(function(v){
        return v.stepNr > 0;
      });
      
      $scope.nextStatus = function() {
        if ($scope.prioritiesSorted.length === 0) {
          return;
        }
        if (!$scope.publication.priority) {
          $scope.publication.priority = $scope.prioritiesSorted[0];
          $scope.savePublication($scope.publication);
        } else {
          var index = $scope.prioritiesSorted.findIndex(function(v){
            return v.id === $scope.publication.priority.id;
          });

          if (index >= ($scope.prioritiesSorted.length - 1) || index < 0) {
            return;
          }

          $scope.publication.priority = $scope.prioritiesSorted[index + 1];
          $scope.savePublication($scope.publication);
        }
      };

      $scope.closeAdditionalOptions  = closeAdditionalOptions;
      $scope.toggleAdditionalOptions = toggleAdditionalOptions;
      $scope.updateNonWatchers       = updateNonWatchers;
      $scope.setPriority             = setPriority;
      $scope.deletePublication       = deletePublication;
      $scope.unsetParent             = unsetParent;
      $scope.setParent               = setParent;
      $scope.setCategory             = setCategory;
    }
  };
}

angular.module("dokiv")
  .directive("publicationSettings", PublicationSettingsDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/PublicationSettingsDirective.js
// module id = 391
// module chunks = 0